import { Http } from "@Services";
import { AccountModel } from "@Interfaces";

const forgot = async (
    data: AccountModel.PostForgotRequest
): Promise<AccountModel.PostForgotResponse> => {
    let response: AccountModel.PostForgotResponse;

    try {
        response = await Http.Request<AccountModel.PostLoginResponse>({
            method: "POST",
            url: "/account/recovery",
            data,
        });
    } catch (error) {
        //  @ts-ignore
        throw Error(error);
        // @todo add user error handler
    }
    return response;
};

export default forgot;
